(function () {
    jQuery('#service-wrap a').click(function () {
        var $el = jQuery(this).closest('.slide-row');
        $el.removeClass('reverse');
        jQuery('.btn-layer-toggle', $el).removeClass('active');
    });
})();